export * from "modules/ParkingGateCodesDashboard/components/DeleteParkingGateCodeModal/hooks/useDeleteParkingGateCodeMutation";
